import React, { useState } from 'react';
import { useFetch, Items } from '@thinkwell/react.common'

const ProductsYolkContext = React.createContext([{}, () => {}, {}, () => {}, () => {}, () => {}]);

const ProductsYolkProvider = (props) => {
  const [items, setItems, upsertItem, getItem, deleteItem] = Items(useState(props && props.value || []))

  const [fetchProductsState, fetchProducts] = useFetch({onSuccess: setItems})

  const value = [items, fetchProducts, fetchProductsState, upsertItem, getItem, deleteItem]
  props.onValue && props.onValue(value)

  return (
    <ProductsYolkContext.Provider value={value}>
      {props.children}
    </ProductsYolkContext.Provider>
  );
};

export { ProductsYolkContext, ProductsYolkProvider}
